import React from 'react';
import { SettingsContainer, Title, SettingsRow, SettingsLabel, ToggleSwitch, Button } from '../styles/StyledComponents';

interface SettingsProps {
  soundEnabled: boolean;
  vibrationEnabled: boolean;
  onToggleSound: () => void;
  onToggleVibration: () => void;
  onBack: () => void;
}

const Settings: React.FC<SettingsProps> = ({
  soundEnabled,
  vibrationEnabled,
  onToggleSound,
  onToggleVibration,
  onBack
}) => {
  return (
    <SettingsContainer>
      <Title>설정</Title>
      
      <SettingsRow>
        <SettingsLabel>소리</SettingsLabel>
        <ToggleSwitch isOn={soundEnabled} onClick={onToggleSound} />
      </SettingsRow>
      
      <SettingsRow>
        <SettingsLabel>진동</SettingsLabel>
        <ToggleSwitch isOn={vibrationEnabled} onClick={onToggleVibration} />
      </SettingsRow>
      
      <Button onClick={onBack} style={{ marginTop: '20px' }}>돌아가기</Button>
    </SettingsContainer>
  );
};

export default Settings;
